import type { Observable } from 'rxjs';
import type { SharedUiGapsName } from './shared-ui-gaps.types';

export abstract class SharedUiGapsService {
    abstract getGap$(colorName: SharedUiGapsName): Observable<string>;
}
